import React, { useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import MasterInvoice from "./MasterInvoice";
import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import GenerateMasterInvoiceModal from "./GenerateMasterInvoiceModal";
import { apiCalll } from "../../../../../../_metronic/_helpers/apiHelpers";
import {useHistory} from 'react-router-dom'
import Swal from "sweetalert2";
import { GetRole } from "../../../../../../_metronic/_helpers/GlobalHelpers";

const MasterInvoiceModal = ({
  showInvoiceModal,
  setShowInvoiceModal,
  data,
  ids,
  startDate,
  endDate,
  search,
}) => {
  const history = useHistory();
  const componentRef = useRef();
  const [downloadIsLoading, setDownloadIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const downloadBillAsPDF = async (invoiceNumber) => {
    const element = componentRef.current;

    const filename = `Master-invoice-${invoiceNumber}.pdf`;

    const options = {
      margin: 0,
      filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 1, logging: false },
      jsPDF: {
        unit: "in",
        format: "a3",
        orientation: "portrait",
      },
    };

    try {
      await html2pdf()
        .set(options)
        .from(element)
        .save();
    } finally {
      setDownloadIsLoading(false);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  function SendInvoiceByEmail(invoiceId) {
    setIsSending(true);
    apiCalll({
      method: "GET",
      link: `/PharmacyAdminManagement/SendMasterInvoicePdf/${invoiceId}`,
    })
      .then(async (data) => {
        if (data[0] === 200) {
          Swal.fire({
            title: "Success!",
            text: "Invoice sent successfully!",
            icon: "success",
            confirmButtonText: "Ok",
          });
        }else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data[1].message,
          });
        } else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: value,
            });
          }
        } else if (data[0] === 401) {
          history.push("/logout");
        } else if (data[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first!",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        }
      })
      .catch((error) => {
        console.log("error", error);
      }).finally(() => {
        setIsSending(false);
      }
      );
  }

  return (
    <>
      <Modal
        show={showInvoiceModal}
        onHide={() => setShowInvoiceModal(false)}
        size="xl"
      >
        <Modal.Body>
          <MasterInvoice invoices={data} componentRef={componentRef} startDate={startDate} endDate={endDate} />
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="secondary"
            onClick={() => {
              setShowInvoiceModal(false);
            }}
          >
            Close
          </Button>
          {!data.id && (
            <div className="my-1 me-5">
              <button
                type="button"
                className="btn btn-light-info my-1 me-12"
                disabled={isSending}
                onClick={() => {
                  setShow(true);
                }}
              >
                External Invoice
              </button>
            </div>
          )}
          {data.id && GetRole() !== "Accord Financial" && (
            <div className="my-1 me-5">
            <button
              type="button"
              className="btn btn-light-info my-1 me-12"
              disabled={isSending}
              onClick={() => {
                SendInvoiceByEmail(data.id)
              }}
            >
              {isSending ? "Sending..." : "Send Invoice"}
            </button>
          </div>
          )}
          <div className="my-1 me-5">
            <button
              type="button"
              className="btn btn-light-primary my-1 me-12"
              disabled={isSending}
              onClick={handlePrint}
            >
              Print Invoice
            </button>
          </div>
          <div className="my-1 me-5">
            <button
              type="button"
              disabled={downloadIsLoading || isSending}
              className="btn btn-light-success my-1 me-12"
              onClick={() => {
                setDownloadIsLoading(true);
                downloadBillAsPDF(data?.masterInvoiceNumber);
              }}
            >
              {downloadIsLoading ? "Downloading..." : "Download PDF"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {show && (
        <GenerateMasterInvoiceModal
          ids={ids}
          show={show}
          setShow={setShow}
          setShowInvoiceModal={setShowInvoiceModal}
          startDate={startDate}
          endDate={endDate}
          search={search}
        />
      )}
    </>
  );
};

export default MasterInvoiceModal;
